<template>
    <div class="round-5 over-hide f-black" style="position: relative" :style="{width,height}">
        <div :id="id" :style="{width,height}"></div>
        <myNodataVchart v-if="rows.length == 0"></myNodataVchart>
    </div>
</template>

<script>
    import myNodataVchart from './myNodataVchart'
    export default {
        name: "myEcharsPie",
        components:{
            myNodataVchart
        },
        props:{
            id:{
                default: 'echar-pie',
                type:String
            },
            rows: {
                default: () => [],
                type: Array
            },
            width:{
                default: '100%',
                type: String
            },
            height:{
                default: '300px',
                type:String
            },
            value_key:{
                type:String
            },
            name_key:{
                type:String
            },
            unit:{
                default: '',
                type:String
            },
            color: {
                default: () => [
                    '#e54d42',
                    '#6739b6',
                    '#0081ff',
                    '#f37b1d',
                    '#8dc63f',
                    '#fbbd08',
                    '#1cbbb4',
                    '#9c26b0',
                    '#39b54a',
                    '#e03997',
                    '#a5673f',
                    '#8799a3'
                ],
                type: Array
            },
        },
        data:function(){
            return{
                myChart:null
            }
        },
        mounted:function(){
        },
        methods: {
        },
        beforeDestroy: function () {
            if(this.myChart){
                this.myChart.dispose();
            }
        },
        watch:{
            rows(newVal){
                var chartDom = document.getElementById(this.id);
                this.myChart = this.$echarts.init(chartDom);

                if(newVal.length > 0){
                    var rows = [];
                    newVal.forEach((item)=>{
                        rows.push({
                            value:item[this.value_key],
                            name:item[this.name_key] + '(' + (item[this.value_key] * 1) + this.unit +')'
                        });
                    });

                    this.myChart.showLoading();
                    var option;

                    option = {
                        // legend: {
                        //     top: 'bottom',
                        // },
                        series: [
                            {
                                type: 'pie',
                                radius: [50, 120],
                                center: ['50%', '50%'],
                                roseType: 'area',
                                itemStyle: {
                                    borderRadius: 8
                                },
                                data: rows
                            }
                        ]
                    };
                    if(this.color.length == 0){
                        option.color = this.$config.chart_colors;
                    }

                    this.myChart.setOption(option);
                    this.myChart.hideLoading();
                }
                else{
                    this.myChart.clear();
                }
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myEcharsPie.vue